<template>
    <div id="contenedor-listado-auditorias-informes-desktop">
    <v-data-table :headers="headers" :items="listadoInformes" :items-per-page="10">
      <template v-slot:[`item.verPdf`]="{ item }">
        <v-tooltip v-if="item.dataFile && item.dataFile !==''? true:false" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            color="red"
            @click="verPdf(item)">
            <v-icon>mdi-file-pdf-box</v-icon>
          </v-btn>
        </template>
        <span>Ver PDF</span>
      </v-tooltip>
      </template>
      <template v-slot:[`item.numeroObservaciones`]="{ item }">
        <v-chip color="base5"
        :to="{ name: 'auditoriaInformeObservaciones', params: { idInforme: item.id } }">
          {{item.observaciones.length}}
        </v-chip>
      </template>
      <template v-slot:[`item.totalObservacionesPorSolventar`]="{ item }">
           <v-chip
            :color="item.colorPorSolventar" dark
            v-if="item.colorPorSolventar !== 'base5'">
            {{item.totalObservacionesPorSolventar}}
            </v-chip>
            <v-chip
            :color="item.colorPorSolventar"
            v-else>
            {{item.totalObservacionesPorSolventar}}
            </v-chip>
      </template>
      <template v-slot:[`item.totalDesglose`]="{ item }">
        <v-chip color="base5">
          {{item.totalDesglose}}
        </v-chip>
      </template>
      <template v-slot:[`item.numeroRespuestas`]="{ item }">
        <v-chip color="base5"
        :to="{ name: 'auditoriaInformeRespuestas', params: { idInforme: item.id } }">
          {{item.respuestas.length}}
        </v-chip>
      </template>
      <template v-slot:[`item.totalDesglosesEnviados`]="{ item }">
        <v-chip
        :color="getColorDesgloseEnviado(item.totalDesglose - item.totalDesglosesEnviados,
        item.totalDesglose )">
          {{item.totalDesglosesEnviados}}
        </v-chip>
      </template>
      <template v-slot:[`item.totalDesglosesPorEnviar`]="{ item }">
        <v-chip color="base5">
          {{item.totalDesglosesPorEnviar}}
        </v-chip>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
      <template v-slot:[`item.numeroOficio`]="{ item }">
        <router-link
          :to="{ name: 'auditoriaInformeObservaciones', params: { idInforme: item.id } }"
        >
          {{ item.numeroOficio }}
        </router-link>
      </template>
      <template v-slot:[`item.fechaRecepcion`]="{ item }">
        <v-chip color="base4">
          <v-icon small left>
            mdi-arrow-right
          </v-icon>
          {{ new Date(`${item.fechaRecepcion} 00:00:0`).toLocaleDateString() }}
        </v-chip>
      </template>
      <template v-slot:[`item.fechaVencimiento`]="{ item }">
        <v-chip :color="item.color" dark>
          {{ new Date(`${item.fechaVencimiento} 00:00:0`).toLocaleDateString() }}
        </v-chip>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :auditoriaInforme="item"></opciones>
      </template>
    </v-data-table>

    <!-- Ventana Eliminar Auditoria Informe -->
      <v-dialog
        v-if="!$apollo.loading && mostrarElimiarAuditoriaInforme"
        v-model="mostrarElimiarAuditoriaInforme"
        width="600"
        persistent>
        <EliminarAuditoriaInforme
        :informe="esteInforme"
        v-on:cerrar="mostrarElimiarAuditoriaInforme=!mostrarElimiarAuditoriaInforme"/>
      </v-dialog>
    <!-- Ventana Editar Auditoria Informe -->
      <v-dialog
        v-if="!$apollo.loading && mostrarEditarAuditoriaInforme"
        v-model="mostrarEditarAuditoriaInforme"
        width="600"
        persistent>
        <EditarAuditoriaInforme
        :informeEditar="esteInforme"
        v-on:cerrar="mostrarEditarAuditoriaInforme=!mostrarEditarAuditoriaInforme"/>
      </v-dialog>
      <!-- Ventana Ver Pdf Informe -->
      <v-dialog
        v-if="!$apollo.loading && esteInforme && mostrarVerPdfAuditoriaInforme"
        v-model="mostrarVerPdfAuditoriaInforme"
        persistent
        scrollable
        width="750px">
        <v-card>
          <v-card-title>
            {{ esteInforme.numeroOficio }}
            / {{ esteInforme.nombre }}
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="cerrarPdf()">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <VistaPreviaPdf
              :ruta-archivo="esteInforme.dataFile">
            </VistaPreviaPdf>
          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!-- Ventana Agregar Auditoria Informe Observacion-->
        <v-dialog
        v-if="!$apollo.loading && mostrarAgregarAuditoriaInformeObservacion"
        v-model="mostrarAgregarAuditoriaInformeObservacion"
        scrollable
        persistent
        width="750px"
        >
        <AgregarAuditoriaInformeObservacion
        :informe="esteInforme"
        v-on:cerrar="mostrarAgregarAuditoriaInformeObservacion=!
        mostrarAgregarAuditoriaInformeObservacion"/>
      </v-dialog>
    </div>
</template>
<script>
import EliminarAuditoriaInforme from '@/components/administracion/auditorias/informes/Eliminar.vue';
import EditarAuditoriaInforme from '@/components/administracion/auditorias/informes/Editar.vue';
import AgregarAuditoriaInformeObservacion from '@/components/administracion/auditorias/observaciones/Nueva.vue';
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';
import VistaPreviaPdf from '@/components/administracion/auditorias/informes/verPdf.vue';
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoAuditoriasInformesDesktop',
  props: {
    listadoInformes: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    EliminarAuditoriaInforme,
    EditarAuditoriaInforme,
    AgregarAuditoriaInformeObservacion,
    FechaHumano,
    VistaPreviaPdf,
    Opciones,
  },
  data() {
    return {
      mostrarElimiarAuditoriaInforme: false,
      mostrarEditarAuditoriaInforme: false,
      mostrarVerPdfAuditoriaInforme: false,
      mostrarAgregarAuditoriaInformeObservacion: false,
      esteInforme: {},
      estaObservacion: {},
      headers: [
        { text: 'Recepción', value: 'fechaRecepcion' },
        { text: 'Número Oficio', value: 'numeroOficio', sortable: true },
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Vencimiento', value: 'fechaVencimiento' },
        { text: 'Observaciones', align: 'center', value: 'numeroObservaciones' },
        { text: 'Por Solventar', align: 'center', value: 'totalObservacionesPorSolventar' },
        { text: 'Desglose', align: 'center', value: 'totalDesglose' },
        { text: 'Respuestas', align: 'center', value: 'numeroRespuestas' },
        { text: 'D.Enviado a Ente', align: 'center', value: 'totalDesglosesEnviados' },
        { text: 'D.Por Enviar', align: 'center', value: 'totalDesglosesPorEnviar' },
        {
          text: 'Anexo', value: 'verPdf', align: 'end', sortable: false,
        },
        /* { text: 'Registro', value: 'createdAt' }, */
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  mounted() {
    eventBus.$on('eliminar-auditoria-informe', (informe) => {
      this.mostrarElimiarAuditoriaInforme = true;
      this.esteInforme = informe;
    });
    eventBus.$on('editar-auditoria-informe', (informe) => {
      this.mostrarEditarAuditoriaInforme = true;
      this.esteInforme = informe;
    });
    eventBus.$on('agregar-auditoria-informe-observacion', (informe) => {
      this.mostrarAgregarAuditoriaInformeObservacion = true;
      this.esteInforme = informe;
    });
    eventBus.$on('ver-pdf-informe', (informe) => {
      this.mostrarVerPdfAuditoriaInforme = true;
      this.esteInforme = informe;
    });
  },
  methods: {
    verPdf(informe) {
      this.mostrarVerPdfAuditoriaInforme = true;
      this.esteInforme = informe;
    },
    cerrarPdf() {
      this.mostrarVerPdfAuditoriaInforme = !this.mostrarVerPdfAuditoriaInforme;
      this.esteInforme = null;
    },
    getColorDesgloseEnviado(porEnviar, totalDesgloses) {
      if (porEnviar === 0 && totalDesgloses !== 0) return 'success';
      return 'base5';
    },
  },

};
</script>
